import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useSearchParams,useLocation } from "react-router-dom";
import { Row, Col, Container, Spinner } from 'react-bootstrap';
import { useForm } from "react-hook-form";
import copy from "copy-to-clipboard";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import Header from "../components/Header";
import SelectComponent from "../components/SelectComponent";
import FullName from "../components/FullName";
import Address from "../components/Address";
import ContactInformation from "../components/ContactInformation";
import SATextInput from "../components/SATextInput";
import BlockHeading from "../components/BlockHeading";
import BottomNavBar from "../components/BottomNavBar";
import StepAway from "../components/StepAway";
import toast, { toastConfig } from 'react-simple-toasts';
import * as familyAPI from "../services/Family";

const parentOrGauridianData = [
    {
        id: 1,
        name: 'Parent',
        value: 'Parent'
    },
    {
        id: 2,
        name: 'Guardian',
        value: 'Guardian'
    }
]

export default function Family() {
    const navigate = useNavigate();
    const location = useLocation();
    let [searchParams] = useSearchParams();
    

    const [loader, setLoader] = useState(false)
    const [PG2Check, setIsPG2Check] = useState(false);
    const [PG2CheckValue, setIsPG2CheckValue] = useState(0);
    const [copyUrl, setCopyUrl] = useState('');
    const [studHCode, setHexCode] = useState('');
    
    toastConfig({
        render: message => <div style={{ backgroundColor: '#cc2427', color: 'white', padding: 10, borderRadius: 10, fontSize: 18, fontWeight: '700' }}>{message}</div>,
    })

    // let hexCode = "";
    const { register, handleSubmit, control, formState: { errors }, reset } = useForm({
        defaultValues: {
            parentOrGuardian1: '',
            parentOrGauridan1LastName: '',
            parentOrGauridan1FirstName: '',
            parentOrGauridan1MiddleName: '',
            parentOrGauridan1Address1: '',
            parentOrGauridan1Address2: '',
            parentOrGauridan1City: '',
            parentOrGauridan1State: '',
            parentOrGauridan1ZipCode: '',
            parentOrGauridian1HomePhone: '',
            parentOrGauridian1CellPhone: '',
            parentOrGauridian1EmailAddress: '',

            parentOrGuardian2: '',
            parentOrGauridan2LastName: '',
            parentOrGauridan2FirstName: '',
            parentOrGauridan2MiddleName: '',
            parentOrGauridan2Address1: '',
            parentOrGauridan2Address2: '',
            parentOrGauridan2City: '',
            parentOrGauridan2State: '',
            parentOrGauridan2ZipCode: '',
            parentOrGauridian2HomePhone: '',
            parentOrGauridian2CellPhone: '',
            parentOrGauridian2EmailAddress: '',

            previousYearsHouseholdIncome: '',
            previousYearsTaxReturn: ''
        }

    });
    useEffect(() => {
        document.title = 'Family | Families of WWII Veterans';
        window.scrollTo({ top: 0, behaviour: "smooth" })
    }, []);

    useEffect(() => {
        let hexCode =location?.state?.hexCode? location.state.hexCode : "";
        if(hexCode === ""){
            hexCode = searchParams.get("code");
        }
        setHexCode(hexCode);
        let modifiedURL = window.location.href.search("code")
        let url = ""
        if (modifiedURL > -1) {
            url = `${window.location.href}`
        } else {

            url = `${window.location.href}?code=${hexCode}`
        }
        setCopyUrl(url)
        
    }, [location?.state?.hexCode,searchParams]);
    
    


    const getFamilyApi = useCallback(async () => {
        setLoader(true)
        try {
            await familyAPI.getFamilyInfo(`student/${studHCode}/family`).then((res) => {
                setLoader(false)
                if (res.status === 200) {
                    let data = res.data;

                    setIsPG2Check(data.checkPG2)
                    data.checkPG2 === "1"?setIsPG2Check(true):setIsPG2Check(false)
                    setIsPG2CheckValue(data.checkPG2)

                    let homeNumber1 = data.pG1HomePhone;
                    let homeNumber2 = data.pG2HomePhone;
                    let cellNumber1 = data.pG1CellNumber
                    let cellNumber2 = data.pG2CellNumber

                   let homePhone1 = homeNumber1 && "(" + homeNumber1.slice(0, 3) + ")" + homeNumber1.slice(3, 6) + "-" + homeNumber1.slice(6, 10);
                   let homePhone2 = homeNumber2 && "(" + homeNumber2.slice(0, 3) + ")" + homeNumber2.slice(3, 6) + "-" + homeNumber2.slice(6, 10);
                   let cellPhone1 = cellNumber1 && "(" + cellNumber1.slice(0, 3) + ")" + cellNumber1.slice(3, 6) + "-" + cellNumber1.slice(6, 10);
                   let cellPhone2 = cellNumber2 && "(" + cellNumber2.slice(0, 3) + ")" + cellNumber2.slice(3, 6) + "-" + cellNumber2.slice(6, 10);
                   
                   reset({


                        "parentOrGuardian1": data.type,
                        "parentOrGauridan1LastName": data.pG1LastName,
                        "parentOrGauridan1FirstName": data.pG1FirstName,
                        "parentOrGauridan1MiddleName": data.pG1MiddleName,
                        "parentOrGauridan1Address1": data.pG1Address,
                        "parentOrGauridan1Address2": data.pG1Address2,
                        "parentOrGauridan1City": data.pG1City,
                        "parentOrGauridan1State": data.pG1StateCode,
                        "parentOrGauridan1ZipCode": data.pG1ZipCode,
                        "parentOrGauridian1HomePhone": data.pG1HomePhone ? homePhone1 : '',
                        "parentOrGauridian1CellPhone": cellPhone1,
                        "parentOrGauridian1EmailAddress": data.pG1EmailAddress,
                        "parentOrGuardian2": data.type2,
                        "parentOrGauridan2LastName": data.pG2LastName,
                        "parentOrGauridan2FirstName": data.pG2FirstName,
                        "parentOrGauridan2MiddleName": data.pG2MiddleName,
                        "parentOrGauridan2Address1": data.pG2Address,
                        "parentOrGauridan2Address2": data.pG2Address2,
                        "parentOrGauridan2City": data.pG2City,
                        "parentOrGauridan2State": data.pG2StateCode.trim(),
                        "parentOrGauridan2ZipCode": data.pG2ZipCode,
                        "parentOrGauridian2HomePhone": data.pG2HomePhone ? homePhone2 : '',
                        "parentOrGauridian2CellPhone": cellPhone2,
                        "parentOrGauridian2EmailAddress": data.pG2EmailAddress,
                        "previousYearsHouseholdIncome": data.houseHoldIncome,
                        "previousYearsTaxReturn": data.taxReturn


                    })
                }else {
                    if(res.status === 204){
                        return 
                    }
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                }
            })
                .catch(function (error) {
                    setLoader(false)
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                    return error
                });
        }
        catch (error) {
            setLoader(false)
            toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
            return error
        }
    }, [reset,studHCode])

    useEffect(() => {
        if (studHCode) {
            getFamilyApi()
        }
    }, [getFamilyApi,studHCode]);




    const onSubmit = async (data) => {
        let familyobj = {
            "type": data.parentOrGuardian1,
            "pG1LastName": data.parentOrGauridan1LastName,
            "pG1FirstName": data.parentOrGauridan1FirstName,
            "pG1MiddleName": data.parentOrGauridan1MiddleName,
            "pG1Address": data.parentOrGauridan1Address1,
            "pG1Address2": data.parentOrGauridan1Address2,
            "pG1City": data.parentOrGauridan1City,
            "pG1StateCode": data.parentOrGauridan1State,
            "pG1ZipCode": data.parentOrGauridan1ZipCode,
            "pG1CellNumber": data.parentOrGauridian1CellPhone.toString().replace(/[^a-zA-Z0-9 ]/g, ''),
            "pG1HomePhone": data.parentOrGauridian1HomePhone.toString().replace(/[^a-zA-Z0-9 ]/g, ''),
            "pG1EmailAddress": data.parentOrGauridian1EmailAddress,
            "type2": data.parentOrGuardian2,
            "checkPG2": PG2CheckValue.toString(),
            "pG2LastName": !PG2Check ? data.parentOrGauridan2LastName : "",
            "pG2FirstName": !PG2Check ? data.parentOrGauridan2FirstName : "",
            "pG2MiddleName": !PG2Check ? data.parentOrGauridan2MiddleName : "",
            "pG2Address": !PG2Check ? data.parentOrGauridan2Address1 : "",
            "pG2Address2": !PG2Check ? data.parentOrGauridan2Address2 : "",
            "pG2City": !PG2Check ? data.parentOrGauridan2City : "",
            "pG2StateCode": !PG2Check ? data.parentOrGauridan2State : "",
            "pG2ZipCode": !PG2Check ? data.parentOrGauridan2ZipCode : "",
            "pG2CellNumber": !PG2Check ? data.parentOrGauridian2CellPhone.toString().replace(/[^a-zA-Z0-9 ]/g, '') : "",
            "pG2HomePhone": !PG2Check ? data.parentOrGauridian2HomePhone.toString().replace(/[^a-zA-Z0-9 ]/g, '') : "",
            "pG2EmailAddress": !PG2Check ? data.parentOrGauridian2EmailAddress : "",
            "houseHoldIncome": data.previousYearsHouseholdIncome,
            "taxReturn": data.previousYearsTaxReturn

        }
        setLoader(true)

        try {
            await familyAPI.postFamilyInfo(familyobj, `student/${studHCode}/family`).then((res) => {
                setLoader(false)
                if (res.status === 200) {
                    navigate("/college-university-considering",{
                        state:{hexCode : studHCode}
                    })
                } else if (res.status === 422) {
                    let errorData = res?.data?.errors
                    if (Object.keys(errorData) && Object.keys(errorData).length > 0) {
                        Object.keys(errorData).forEach((err) => {
                            toast(errorData[err][0], { position: 'top-right', backgroundColor: 'red' })
                        })
                    }
                } else {
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                }
            })
                .catch(function (error) {
                    setLoader(false)
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                    return error
                });
        }
        catch (error) {
            setLoader(false)
            toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
        }

    }
    const handleBack = () => {
        navigate("/current-education",{
            state:{hexCode : studHCode}
        })
    }
    const handleNavBack = (to) => {
        navigate(to,{
            state:{hexCode : studHCode}
        })
    }
    const handleCopy = () => {
        copy(copyUrl);
        alert(`URLGOESHERE copied to your clipboard. Save this URL.`);
    }
    const handlepg2Check = (e) => {
        setIsPG2Check(e.target.checked)
        e.target.checked?setIsPG2CheckValue(1): setIsPG2CheckValue(0)
    }

    return (
        <>
            <Header title="Scholarship Application" />
            {loader && <div lg={12} md={12} sm={12} className="loaderContainer">
                <Spinner animation="border" variant="primary" /> </div>}
            <Container className='py-3 py-md-4 py-md-5'>
                <Row>
                    <Col lg={12}>
                        <StepAway handleCopy={handleCopy} copyInputValue={copyUrl} />
                        <Nav navbType="student" handleNavBack={handleNavBack}/>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <BlockHeading title="Parent or Guardian 1" />
                            <Row>
                                <Col lg={4}>
                                    <SelectComponent
                                        register={register}
                                        errors={errors}
                                        data={parentOrGauridianData}
                                        isStrong={true}
                                        htmlFor={"parentOrGuardian1"}
                                        label={"Parent or Gaurdian:"}
                                        name={"parentOrGuardian1"}
                                        errMsg={errors?.parentOrGuardian1?.message}
                                        id={"parentOrGuardian1Help"}
                                        requiredObj={{ required: "Parent or Guardian required" }}
                                    />
                                </Col>
                            </Row>
                            <h4 className="text-secondary mt-3">Name:</h4>
                            <FullName
                                register={register}
                                errors={errors}
                                htmlForLastName={"parentOrGauridan1LastName"}
                                nameLastName={"parentOrGauridan1LastName"}
                                lastNameId={"parentOrGauridan1LastNameHelp"}
                                lastNameErrMsg={errors.parentOrGauridan1LastName?.message}
                                htmlForFirstName={"parentOrGauridan1FirstName"}
                                nameFirstName={"parentOrGauridan1FirstName"}
                                firstNameId={"parentOrGauridan1FirstNameHelp"}
                                firstNameErrMsg={errors.parentOrGauridan1FirstName?.message}
                                htmlForMiddleName={"parentOrGauridan1MiddleName"}
                                nameMiddleName={"parentOrGauridan1MiddleName"}

                            />
                            <h4 className="text-secondary">Address:</h4>
                            <Address
                                register={register}
                                errors={errors}
                                htmlForAddress1={"parentOrGauridan1Address1"}
                                address1Name={"parentOrGauridan1Address1"}
                                addressId={"parentOrGauridan1Address1Help"}
                                errMsg={errors.parentOrGauridan1Address1?.message}
                                htmlForAddress2={"parentOrGauridan1Address2"}
                                address2Name={"parentOrGauridan1Address2"}
                                htmlForCity={"parentOrGauridan1City"}
                                cityName={"parentOrGauridan1City"}
                                cityId={"parentOrGauridan1CityHelp"}
                                cityErrMsg={errors.parentOrGauridan1City?.message}
                                htmlForState={"parentOrGauridan1StateHtmlFor"}
                                stateName={"parentOrGauridan1State"}
                                stateId={"parentOrGauridan1StateHelp"}
                                stateErrMsg={errors.parentOrGauridan1State?.message}
                                htmlForZipCode={"parentOrGauridan1ZipCode"}
                                zipCodeName={"parentOrGauridan1ZipCode"}
                                zipCodeErrMsg={errors.parentOrGauridan1ZipCode?.message}
                                zipcodeId={"parentOrGauridan1ZipCodeHelp"}

                            />
                            <h4 className="text-secondary">Contact Information:</h4>
                            <ContactInformation
                                register={register}
                                errors={errors}
                                control={control}
                                htmlForHomePhone={"parentOrGauridian1HomePhone"}
                                homePhoneName={"parentOrGauridian1HomePhone"}
                                homePhoneId={"parentOrGauridian1HomePhone"}
                                homePhoneErrMsg={errors.parentOrGauridian1HomePhone?.message}
                                htmlForCellNumber={"parentOrGauridian1CellPhone"}
                                cellPhoneName={"parentOrGauridian1CellPhone"}
                                cellPhoneId={"parentOrGauridian1CellPhoneHelp"}
                                cellPhoneErrMsg={errors.parentOrGauridian1CellPhone?.message}
                                htmlForEmailAddress={"parentOrGauridian1EmailAddress"}
                                emailAddressName={"parentOrGauridian1EmailAddress"}
                                emailAddressId={"parentOrGauridian1EmailAddressHelp"}
                                emailAddressErrMsg={errors.parentOrGauridian1EmailAddress?.message}

                            />
                            <hr />
                            <BlockHeading title="Parent or Guardian 2" />
                            <div className="form-check mb-3">
                                <input className="form-check-input" type="checkbox" checked={PG2Check}
                                    id="secondParentCheck" onChange={handlepg2Check} />
                                <label className="form-check-label" htmlFor="secondParentCheck">
                                    Check if not applicable.</label>
                            </div>
                            {!PG2Check &&
                                <div>
                                    <Row>
                                        <Col lg={4}>
                                            <SelectComponent
                                                register={register}
                                                errors={errors}
                                                data={parentOrGauridianData}
                                                isStrong={PG2Check === true ? false : true}
                                                label={"Parent or Gaurdian:"}
                                                htmlFor={"parentOrGuardian2"}
                                                name={"parentOrGuardian2"}
                                                errMsg={errors?.parentOrGuardian2?.message}
                                                id={"parentOrGuardian2Help"}
                                                requiredObj={
                                                    { required: "Parent or Guardian required" }}
                                            />
                                        </Col>
                                    </Row>
                                    <h4 className="text-secondary mt-3">Name:</h4>
                                    <FullName
                                        register={register}
                                        errors={errors}
                                        htmlForLastName={"parentOrGauridan2LastName"}
                                        nameLastName={"parentOrGauridan2LastName"}
                                        lastNameId={"parentOrGauridan2LastNameHelp"}
                                        lastNameErrMsg={errors.parentOrGauridan2LastName?.message}
                                        htmlForFirstName={"parentOrGauridan2FirstName"}
                                        nameFirstName={"parentOrGauridan2FirstName"}
                                        firstNameId={"parentOrGauridan2FirstNameHelp"}
                                        firstNameErrMsg={errors.parentOrGauridan2FirstName?.message}
                                        htmlForMiddleName={"parentOrGauridan2MiddleName"}
                                        nameMiddleName={"parentOrGauridan2MiddleName"}

                                    />
                                    <h4 className="text-secondary">Address:</h4>
                                    <Address
                                        register={register}
                                        errors={errors}
                                        htmlForAddress1={"parentOrGauridan2Address1"}
                                        address1Name={"parentOrGauridan2Address1"}
                                        addressId={"parentOrGauridan2Address1Help"}
                                        errMsg={errors.parentOrGauridan2Address1?.message}
                                        htmlForAddress2={"parentOrGauridan2Address2"}
                                        address2Name={"parentOrGauridan2Address2"}
                                        htmlForCity={"parentOrGauridan2City"}
                                        cityName={"parentOrGauridan2City"}
                                        cityId={"parentOrGauridan2CityHelp"}
                                        cityErrMsg={errors.parentOrGauridan2City?.message}
                                        htmlForState={"parentOrGauridan2StateHtmlFor"}
                                        stateName={"parentOrGauridan2State"}
                                        stateId={"parentOrGauridan2StateHelp"}
                                        stateErrMsg={errors.parentOrGauridan2State?.message}
                                        htmlForZipCode={"parentOrGauridan2ZipCode"}
                                        zipCodeName={"parentOrGauridan2ZipCode"}
                                        zipCodeErrMsg={errors.parentOrGauridan2ZipCode?.message}
                                        zipcodeId={"parentOrGauridan2ZipCodeHelp"}

                                    />
                                    <h4 className="text-secondary">Contact Information:</h4>
                                    <ContactInformation
                                        register={register}
                                        errors={errors}
                                        control={control}
                                        htmlForHomePhone={"parentOrGauridian2HomePhone"}
                                        homePhoneName={"parentOrGauridian2HomePhone"}
                                        homePhoneId={"parentOrGauridian2HomePhone"}
                                        homePhoneErrMsg={errors.parentOrGauridian2HomePhone?.message}
                                        htmlForCellNumber={"parentoRGauridian2CellNumber"}
                                        cellPhoneName={"parentOrGauridian2CellPhone"}
                                        cellPhoneId={"parentOrGauridian2CellPhoneHelp"}
                                        cellPhoneErrMsg={errors.parentOrGauridian2CellPhone?.message}
                                        htmlForEmailAddress={"parentOrGauridian2EmailAddress"}
                                        emailAddressName={"parentOrGauridian2EmailAddress"}
                                        emailAddressId={"parentOrGauridian2EmailAddressHelp"}
                                        emailAddressErrMsg={errors.parentOrGauridian2EmailAddress?.message}

                                    />
                                </div>}
                            <hr />
                            <BlockHeading title="Household Income:" />
                            <Row>
                                <Col lg={4}>
                                    <SATextInput
                                        register={register}
                                        htmlFor={"previousYearsHouseholdIncome"}
                                        name={"previousYearsHouseholdIncome"}
                                        label={"Previous year's household income:"}
                                        isStrong={true}
                                        requiredText={"Previous year's household income is required!"}
                                        type={"text"}
                                        placeholder={"Previous year's household income (required)"}
                                        errors={errors}
                                        id={"previousYearsHouseholdIncome"}
                                        maxLength={10}
                                        errMsg={errors.previousYearsHouseholdIncome?.message}
                                        requiredObj={{
                                            required: "Previous year's household income is required",
                                            pattern: {
                                                value: /^[0-9]{1,}$/, message: "Invalid Previous year's Household Income!"
                                            }
                                        }}
                                    />
                                </Col>
                                <Col lg={4}>
                                    <SATextInput
                                        register={register}
                                        htmlFor={"previousYearsTaxReturn"}
                                        name={"previousYearsTaxReturn"}
                                        label={"Previous year's tax return:"}
                                        isStrong={true}
                                        requiredText={"Previous year's tax return is required!"}
                                        type={"text"}
                                        maxLength={10}
                                        placeholder={"Previous year's tax return (required)"}
                                        errors={errors}
                                        id={"PreviousYearsTaxReturn"}
                                        errMsg={errors.previousYearsTaxReturn?.message}
                                        requiredObj={{
                                            required: "Previous year's tax return is required",
                                            pattern: {
                                                value: /^[0-9]{1,}$/, message: "Invalid Previous year's tax return!"
                                            }
                                        }}
                                    />
                                </Col>
                            </Row>
                            <BottomNavBar handleBack={handleBack}
                                submitButtonTitle="NEXT" />
                        </form>
                    </Col>
                </Row>
            </Container>
            <Footer />
        </>
    );
}